<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" :disabled="visible_tabs">
        <span slot="tab">
          <div style="display: flex">
            <div style="width: 130px">{{ this.$t("Pliki z foldery") }}</div>
            <div>
              <a-badge
                :offset="[0, -8]"
                showZero="true"
                :number-style="{ backgroundColor: '#2db7f5' }"
                :count="totalFiles"
                :overflowCount="999"
              >
                <a href="#" class="head-example" />
              </a-badge>
            </div>
          </div>
        </span>
        <firstTab
          :InitInfo="InitInfo"
          :fileList="fileList"
          :key_words="key_words"
          :responsible="responsible"
          :specialization="specialization"
          :user_setup="user_setup"
          @changeVisibleTabs="changeVisibleTabs"
          @updateTotalFile="updateTotalFile"
          @updateFiles="updateFiles"
          @changeSpinning="changeSpinning"
          @refresh="loadFilesAndSettings"
          @filterDocList="filterDocList"
        />
      </a-tab-pane>
      <a-tab-pane key="2" :disabled="visible_tabs">
        <span slot="tab">
          <div style="display: flex">
            <div style="width: 130px">{{ this.$t("Pliki z e-maila") }} </div>
            <div>
              <a-badge
                :offset="[0, -8]"
                showZero="true"
                :number-style="{ backgroundColor: '#2db7f5' }"
                :count="totalFilesFromMail"
                :overflowCount="999"
              >
                <a href="#" class="head-example" />
              </a-badge>
            </div>
          </div>
        </span>
        <secondTab
          :InitInfo="InitInfo"
          :fileList="fileList"
          :key_words="key_words"
          :responsible="responsible"
          :specialization="specialization"
          :user_setup="user_setup"
          @visible_tabs="visible_tabs"
          @updateTotalFileFromMail="updateTotalFileFromMail"
          @updateFiles="updateFiles"
          @changeSpinning="changeSpinning"
          @refresh="loadFilesAndSettings"
          @filterDocList="filterDocList"
        />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import firstTab from "@/components/firstStageTabs/firstTab.vue";
import secondTab from "@/components/firstStageTabs/secondTab.vue";

export default {
  props: [
    "fileList",
    "InitInfo",
    "key_words",
    "specialization",
    "responsible",
    "user_setup",
  ],
  components: {
    firstTab,
    secondTab,
  },
  data: function () {
    return {
      totalFiles: 0,
      totalFilesFromMail: 0,
      visible_tabs: false
    };
  },
  methods: {
    updateTotalFile(val) {
      this.totalFiles = val;
    },
    updateTotalFileFromMail(val) {
      this.totalFilesFromMail = val;
    },
    changeVisibleTabs(val) {
      this.visible_tabs = val;
    }
  },
  mounted() {
      this.totalFilesFromMail = this.InitInfo.totalForMail;
  }
};
</script>